import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// Routes
import { APP_ROUTING } from './app.routes';
// Components - Generic
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/general/header/header.component';
import { FooterComponent } from './components/general/footer/footer.component';
import { CotizadorComponent } from './components/general/cotizador/cotizador.component';
// Components - Main
import { HomeComponent } from './components/home/home.component';
import { KnowComponent } from './components/know/know.component';
import { ComprarComponent } from './components/comprar/comprar.component';
import { ContactComponent } from './components/contact/contact.component';
import { ServicesComponent } from './components/services/services.component';
import { CompararComponent } from './components/comparar/comparar.component';
import { CompaniesComponent } from './components/companies/companies.component';
import { SolicitarComponent } from './components/solicitar/solicitar.component';
import { FrequentQuestionsComponent } from './components/frequent-questions/frequent-questions.component';
// Components - intermediarios
import { PerfilComponent } from './components/intermediarios/perfil/perfil.component';
import { CotizacionComponent } from './components/intermediarios/cotizacion/cotizacion.component';
import { PlataformaComponent } from './components/intermediarios/plataforma/plataforma.component';
import { IntermediariosComponent } from './components/intermediarios/intermediarios.component';
import { FrequentQuestionsComponent as IntermediariosQuestionsComponent } from './components/intermediarios/frequent-questions/frequent-questions.component';
import { MenuIntermediariosComponent } from './components/general/menu-intermediarios/menu-intermediarios.component';
import { PasajeroComponent } from './components/intermediarios/pasajero/pasajero.component';
import { ClienteComponent } from './components/intermediarios/cliente/cliente.component';

import { ConfirmarComponent } from './components/confirmar/confirmar.component';
import { ComisionComponent } from './components/intermediarios/comision/comision.component';

// Components - promociones
import { PromocionesComponent } from './components/promociones/promociones.component';
import { CompraComponent as PromocionesCompraComponent } from './components/promociones/compra/compra.component';
import { DetalleComponent as PromocionesDetalleComponent } from './components/promociones/detalle/detalle.component';
// Components - Modals
import { CompararComponent as CompararModal } from './components/general/modals/comparar/comparar.component';
import { CompaniesComponent as CompaniesModal } from './components/general/modals/companies/companies.component';
import { ServicesComponent as ServicesModal } from './components/general/modals/services/services.component';
import { ComprarComponent as ComprarModal } from './components/general/modals/comprar/comprar.component';
import { PromocionesComprarComponent } from './components/general/modals/promociones-comprar/promociones-comprar.component';
import { IntermediariosComponent as IntermediariosModal } from './components/general/modals/intermediarios/intermediarios.component';
// Services
import {CurrencyService} from './services/currency.service';
// Other Imports

// HTTP CORE MODULE
import {HttpModule, Http} from '@angular/http';
// Lang
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { TermsCondComponent } from './components/general/modals/terms-cond/terms-cond.component';
// Modal
import { NotificationComponent  as NotificationModal} from  './components/general/modals/notification/notification.component';
import { BusquedaComponent as BusquedaModal } from './components/intermediarios/cotizacion/busqueda/busqueda.component';
import { PoliticsComponent } from './components/politics/politics.component';
// Cotizador Web Info
import {  CotizadorInfoComponent  } from './components/cotizador/cotizadorinfo.component';
import { StepwizardComponent } from './components/general/stepwizard/stepwizard.component';
import { UpGradeComponent } from './components/up-grade/up-grade.component';
import { PasajerosComponent } from './components/general/modals/pasajeros/pasajeros.component';
import { RegistroComponent } from './components/intermediarios/registro/registro.component';
import { ValidacionComponent } from './components/intermediarios/validacion/validacion.component';
import { ConfirmarCorreoComponent } from './components/intermediarios/registro/confirmar-correo/confirmar-correo.component';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: Http) {
    return new TranslateHttpLoader(http,/*'/Sites/smi/angular/assets/i18n/','.json'*/);
}

@NgModule({
	declarations: [
		AppComponent,
		// General
		HeaderComponent,FooterComponent,
		// Sections
		HomeComponent,CotizadorComponent,ContactComponent,
		FrequentQuestionsComponent,	CompaniesComponent,ServicesComponent,KnowComponent,
		// Intermediarios
		IntermediariosComponent,IntermediariosQuestionsComponent,PerfilComponent,PlataformaComponent,
		// Promociones
		PromocionesComponent,PromocionesCompraComponent,PromocionesDetalleComponent,
		MenuIntermediariosComponent,CotizacionComponent,ComprarComponent,SolicitarComponent,CompararComponent,
		// Modals
		CompararModal,CompaniesModal,ServicesModal,ComprarModal,PromocionesComprarComponent,IntermediariosModal,  ConfirmarComponent, ComisionComponent, PasajeroComponent, ClienteComponent, TermsCondComponent, NotificationModal, BusquedaModal, PoliticsComponent,
		// Other Declarations
		CotizadorInfoComponent,
    UpGradeComponent,
		StepwizardComponent,
		PasajerosComponent,
    RegistroComponent,
    ValidacionComponent,
    ConfirmarCorreoComponent
	],
	imports: [
    ReactiveFormsModule,
    FormsModule,
		HttpModule,
		BrowserModule,
		APP_ROUTING,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [Http]
			}
		})
	],
	exports: [
		TranslateModule
	],
	providers: [
    CurrencyService
  ],
	bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts